import { render, staticRenderFns } from "./Histories.vue?vue&type=template&id=af984afa&scoped=true"
import script from "./Histories.vue?vue&type=script&lang=ts"
export * from "./Histories.vue?vue&type=script&lang=ts"
import style0 from "./Histories.vue?vue&type=style&index=0&id=af984afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af984afa",
  null
  
)

export default component.exports